import React, { useEffect, useState } from 'react';
import { Form, Col, Input, Button, Transfer } from 'antd';
import { useMediaQuery } from 'react-responsive'
import RequestHandler from '../../util/RequestHandler';
import {lowerCase} from "lodash";

const userId = localStorage.getItem("userId");
const layout = {
  labelCol: {
    span: 4,
  },
  wrapperCol: {
    span: 16,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};

const GroupUpdate = (props) => {
  const isDesktopOrLaptop = useMediaQuery({ query: '(min-device-width: 1224px)' });
  const isTabletOrMobileDevice = useMediaQuery({ query: '(max-device-width: 1224px)' });

  const [groupName, setGroupName] = useState(props.groupName);
  const [loading, setLoading] = useState(false);
  const [mockDataTenant, setmockDataTenant] = useState([]);
  const [mockDataUser, setmockDataUser] = useState([]);
  const [targetKeysTenant, setTargetKeysTenant] = useState([]);
  const [groupId, setGroupId] = useState(props.groupId);
  const [targetKeysUser, setTargetKeysUser] = useState([]);

  useEffect(() => {
    RequestHandler.get(`/User/GetUserTenants/${userId}`).then(response => {
      getMockTenant(response);
      const tenantList = [];
      response.map((item) => {
        tenantList.push(item.id)
      });

      RequestHandler.post(`/User/GetUserListForTenants`, { tenants: tenantList }, false).then(res => {
        getMockUser(res)
      });
    });

    RequestHandler.get(`/Group/GetTenantGroup/${props.groupId}`).then(response => {
      const tenants = [];
      response.map((item) => {
        tenants.push(item.tenantId);
      });
      setTargetKeysTenant(tenants);
    });

    RequestHandler.get(`/Group/GetUserGroup/${props.groupId}`).then(response => {
      const users = [];
      response.map((item) => {
        users.push(item.userId);
      });
      setTargetKeysUser(users);
    });

    setGroupId(props.groupId)
    setGroupName(props.groupName)
  }, [setGroupName, props.groupName, setTargetKeysUser, setTargetKeysTenant, setGroupId, props.groupId]);

  const onChangeName = (e) => {
    setGroupName(e.target.value)
  }

  const onFinish = (values) => {
    RequestHandler.put(`/Group`, {
      id: groupId,
      name: values.name,
      tenantIds: targetKeysTenant,
      userIds: targetKeysUser
    }).then(res => {
      setTimeout(function () {
        window.location.reload();
      }.bind(this), 2000);
    }).catch(function (error) {
      setLoading(false);
    });
  };

  const onFinishFailed = () => setLoading(false);

  const getMockTenant = (value) => {
    const targetKeysTenant = [];
    const mockDataTenant = [];
    value.map((item, index) => {
      const data = {
        key: item.id,
        title: item.name,
        description: ``,
      };
      if (data.chosen) {
        targetKeysTenant.push(data.key);
      }
      mockDataTenant.push(data);
    })
    setmockDataTenant(mockDataTenant)
  };

  const getMockUser = (value) => {
    const targetKeysUser = [];
    const mockDataUser = [];
    value.map((item, index) => {
      const data = {
        key: item.id,
        title: `${item.firstName} ${item.lastName}`,
        description: ``,
      };
      if (data.chosen) {
        targetKeysUser.push(data.key);
      }
      mockDataUser.push(data);
    })
    setmockDataUser(mockDataUser)
  };

  const filterOptionUser = (inputValue, option) => lowerCase(option.title).indexOf(lowerCase(inputValue)) > -1;

  const handleChangeUser = targetKeysUser => {
    setTargetKeysUser(targetKeysUser)
  };

  const filterOptionTenant = (inputValue, option) => lowerCase(option.title).indexOf(lowerCase(inputValue)) > -1;

  const handleChangeTenant = targetKeysTenant => {
    setTargetKeysTenant(targetKeysTenant)
  };

  return (
    <div>
      {isDesktopOrLaptop && <>
        <Form
          {...layout}
          name="basic"
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          fields={[
            { name: "name", value: groupName },
          ]}
        >
          <Form.Item
            label="Grup Adı"
            name="name"
            rules={[
              {
                required: true,
                message: 'İsim alanını boş bırakmayın',
              },
            ]}
          >
            <Input onChange={onChangeName} />
          </Form.Item>
          <Form.Item
            label="Şirketler"
            name="users"
          >
            <Transfer
              dataSource={mockDataTenant}
              showSearch
              locale={
                {
                  searchPlaceholder: "Arama Yapınız",
                  notFoundContent: 'Liste Boş',
                  itemUnit: 'Şirket',
                  itemsUnit: 'Şirket',
                  selectAll: 'Hepsini Seç',
                  selectInvert: 'Seçimleri Kaldır'
                }
              }
              listStyle={{
                width: 300,
                height: 250,
              }}
              titles={['(-)', '(+)']}
              filterOption={filterOptionTenant}
              targetKeys={targetKeysTenant}
              onChange={handleChangeTenant}
              render={item => item.title}
            />
          </Form.Item>
          <Form.Item
            label="Kullanıcılar"
            name="tenants"
          >

            <Transfer
              dataSource={mockDataUser}
              showSearch
              locale={
                {
                  searchPlaceholder: "Arama Yapınız",
                  notFoundContent: 'Liste Boş',
                  itemUnit: 'Kullanıcı',
                  itemsUnit: 'Kullanıcı',
                  selectAll: 'Hepsini Seç',
                  selectInvert: 'Seçimleri Kaldır'
                }
              }
              listStyle={{
                width: 300,
                height: 250,
              }}
              titles={['(-)', '(+)']}

              filterOption={filterOptionUser}
              targetKeys={targetKeysUser}
              onChange={handleChangeUser}
              render={item => item.title}
            />
          </Form.Item>

          <Form.Item {...tailLayout}>
            <Button type="primary" style={{ marginLeft: '100%' }} htmlType="submit" onClick={() => setLoading(true)} loading={loading}>
              Güncelle
            </Button>
          </Form.Item>
        </Form>
      </>}
      {isTabletOrMobileDevice && <>
        <Form
          {...layout}
          name="basic"
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          fields={[
            { name: "name", value: groupName },
          ]}
        >
          <Form.Item
            label="Grup Adı"
            name="name"
            rules={[
              {
                required: true,
                message: 'İsim alanını boş bırakmayın',
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Şirketler"
            name="users"
          >
            <Transfer
              dataSource={mockDataTenant}
              style={{ marginLeft: '-24%' }}
              showSearch
              locale={
                {
                  searchPlaceholder: "Arama Yapınız",
                  notFoundContent: 'Liste Boş',
                  itemUnit: 'Şirket',
                  itemsUnit: 'Şirket',
                  selectAll: 'Hepsini Seç',
                  selectInvert: 'Seçimleri Kaldır'
                }
              }
              listStyle={{
                width: 300,
                height: 250,
              }}
              titles={['(-)', '(+)']}
              filterOption={filterOptionTenant}
              targetKeys={targetKeysTenant}
              onChange={handleChangeTenant}
              render={item => item.title}
            />
          </Form.Item>
          <Form.Item
            label="Kullanıcılar"
            name="tenants"
          >

            <Transfer
              dataSource={mockDataUser}
              showSearch
              style={{ marginLeft: '-24%' }}
              locale={
                {
                  searchPlaceholder: "Arama Yapınız",
                  notFoundContent: 'Liste Boş',
                  itemUnit: 'Kullanıcı',
                  itemsUnit: 'Kullanıcı',
                  selectAll: 'Hepsini Seç',
                  selectInvert: 'Seçimleri Kaldır'
                }
              }
              listStyle={{
                width: 300,
                height: 250,
              }}
              titles={['(-)', '(+)']}

              filterOption={filterOptionUser}
              targetKeys={targetKeysUser}
              onChange={handleChangeUser}
              render={item => item.title}
            />
          </Form.Item>

          <Col span={20}>
            <Form.Item {...tailLayout}>
              <Button type="primary" style={{ marginLeft: '100%' }} htmlType="submit" onClick={() => setLoading(true)} loading={loading}>
                Güncelle
              </Button>
            </Form.Item>
          </Col>
        </Form>
      </>}

    </div>

  );
}

export default GroupUpdate
